module.exports = __webpack_public_path__ + "static/media/2025_Illit_Forsikringit.171f1571.pdf";